import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  revenueProjectionsDescriptionPoint1: {
    id: "funding-application: revenue projections doc upload description point 1",
    defaultMessage:
      "Please provide your forecasted revenue projections. This can be a high-level overview, you can use our <a>template</a> if you don’t already have one.",
  },
  cashFlowForecastDescriptionPoint2: {
    id: "funding-application: cash flow forecast doc upload description point 2",
    defaultMessage: "Your forecast should show at least the next six months of revenue/cash flow, broken down by month",
  },
  revenueProjectionsTitle: {
    id: "funding-application: revenue projections title",
    defaultMessage: "Upload your revenue projections",
  },
  debtAgreementsDescriptionPoint1: {
    id: "funding-application: debt agreements doc upload description point 1",
    defaultMessage:
      "Please provide copies of any debt agreements relating to any material, secured debt in your company",
  },
  debtAgreementsTitle: {
    id: "funding-application: upload debt agreements",
    defaultMessage: "Upload your company debt agreements",
  },
  havingTroubleFooterText: {
    id: "funding-application: doc upload footer message",
    defaultMessage: "Having trouble? <link>Contact our team</link>",
  },
  poolBancarioDescriptionPoint1: {
    id: "funding-application: Pool Bancario doc upload description point 1",
    defaultMessage: "Please provide your Pool Bancario in an excel format",
  },
  poolBancarioDescriptionPoint2: {
    id: "funding-application: Pool Bancario doc upload description point 2",
    defaultMessage: "Your document should show any company debt within the last calendar month",
  },
  poolBancarioTitle: {
    id: "funding-application: upload company Pool Bancario",
    defaultMessage: "Upload your company Pool Bancario",
  },
  purchaseOrdersDescriptionPoint1: {
    id: "funding-application: purchase orders doc upload description point 1",
    defaultMessage: "Please provide copies of any material, unfulfilled purchase orders",
  },
  purchaseOrdersDescriptionPoint2: {
    id: "funding-application: purchase orders doc upload description point 2",
    defaultMessage:
      "Please also provide (where possible) other documentation relating to commitments from retailers for future orders",
  },
  purchaseOrdersTitle: {
    id: "funding-application: upload purchase orders",
    defaultMessage: "Upload your purchase orders",
  },
  skipCheckboxLabel: {
    id: "funding-application: doc upload skip checkbox label",
    defaultMessage: "Our company does not have this document",
  },
  skipCheckboxDividerLabel: {
    id: "funding-application: doc upload skip divider label",
    defaultMessage: "or",
    description: "shown on a divider to separate the file upload and 'we cannot provide this file' checkbox",
  },
  susaDescriptionPoint1: {
    id: "funding-application: susa doc upload description point 1",
    defaultMessage: "Please provide your SUSA in the yearly overview format",
  },
  susaDescriptionPoint2: {
    id: "funding-application: susa doc upload description point 2",
    defaultMessage: "You can view export guidance on the <link>DATEV help centre</link>",
  },
  susaTitle: {
    id: "funding-application: upload company susa",
    defaultMessage: "Upload your company SUSA",
  },
  managementAccountsDescription: {
    id: "funding-application: management account upload description",
    defaultMessage: `
    <li>Please provide your management accounts (Profit & Loss Statement and Balance Sheet) in excel format</li>
    <li>Accounts should be presented monthly or quarterly for <em>at minimum</em> the <strong>most recent {duration} months
    </strong> that have been closed from an accounting perspective</li>
    <li>Please note, if there is a group structure related to the legal entity requesting financing, we would need
    the Consolidated Group Management Accounts</li>
    `,
    description: "Describes the requirements for the accounting documents that will be needed",
  },
  profitAndLossDescription: {
    id: "funding-application: profit and loss upload description",
    defaultMessage: `
    <p>Please provide your Profit & Loss Statement in either a XLSX or PDF format.</p>
    <ul>
      <li>The uploaded accounts should be monthly, rather than annually or quarterly.</li>
      <li>Include at minimum the most recent {duration} months that have been closed from an accounting perspective.</li>
      <li>Please note, if there is a group structure related to the legal entity requesting financing, we would need
      the Consolidated Group Management Accounts</li>
      <li>You may upload multiple files if needed.</li>
    </ul>
    <p>You can find an example of a Profit & Loss statement <a>here</a>.</p>
    `,
  },
  balanceSheetDescription: {
    id: "funding-application: balance sheet upload description",
    defaultMessage: `
    <p>Please provide your Balance Sheet in either a XLSX or PDF format.</p>
    <ul>
      <li>The uploaded accounts should be monthly, rather than annually or quarterly.</li>
      <li>Include at minimum the most recent {duration} months that have been closed from an accounting perspective.</li>
      <li>Please note, if there is a group structure related to the legal entity requesting financing, we would need
      the Consolidated Group Management Accounts</li>
      <li>You may upload multiple files if needed.</li>
    </ul>
    <p>You can find an example of a Balance Sheet <a>here</a>.</p>
    `,
  },
  uploadDocumentsFieldLabel: {
    id: "funding-application: upload documents field label",
    defaultMessage: "Upload documents",
  },
  updateUploadsFieldLabel: {
    id: "funding-application: update document uploads field label",
    defaultMessage: "Update your uploads",
  },
  reportingCurrencyFieldLabel: {
    id: "funding-application: reporting currency field label",
    defaultMessage: "Reporting currency",
  },
  reportingCurrencyHelperText: {
    id: "funding-application: reporting currency helper text",
    defaultMessage: "For accurate statement assessment",
  },
  accountingSkipCheckboxLabel: {
    id: "funding-application: accounting skip checkbox label",
    defaultMessage:
      "I cannot or prefer not to provide both Profit and Loss and Balance Sheet data, and I acknowledge that this will limit my maximum approved amount to {capAmount}.",
  },
  validationIssuesInstruction: {
    id: "funding-application: document validation issues instruction",
    defaultMessage:
      "Our validation system found some issues in the uploaded documents. You may correct them or, if you believe the system is mistaken, simply click Confirm.",
  },
});
